import { render, staticRenderFns } from "./ProzessMetastatusTable.vue?vue&type=template&id=2a84eba0"
import script from "./ProzessMetastatusTable.vue?vue&type=script&lang=js"
export * from "./ProzessMetastatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports